import { useTranslation } from 'react-i18next';
import { Fragment, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from 'entities/Auth';

import _ from 'lodash';
import { AFRICA_SAFARI_DARK_LOGOS, TANZANIA_SPECIALIST_DARK_LOGOS } from 'utils/constants';

import NavigationLink from './NavigationLink';
import LanguageSelector from 'components/LanguageSelector';
import MobileNavigation from 'components/MobileNavigation';
import { URLS } from 'config/urls';

const Navigation = () => {
  const { t, i18n } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const tanzaniaSpecialistLogo = useMemo(() => {
    return _.get(TANZANIA_SPECIALIST_DARK_LOGOS, i18n.language);
  }, [i18n.language]);

  const africaSafariLogo = useMemo(() => {
    return _.get(AFRICA_SAFARI_DARK_LOGOS, i18n.language);
  }, [i18n.language]);

  const handleLogout = useCallback(async () => {
    try {
      await logout();
      navigate(URLS.LOGIN);
    } catch (error) {
      // TODO: Show error to the user
      console.error('Failed to logout', error);
    }
  }, [logout, navigate]);

  return (
    <Fragment>
      <div className={`w-full h-[var(--navigation-height)] bg-beige flex justify-center`}>
        <div className='max-w-[1440px] w-full content-center px-[24px]'>
          <div className='flex align-center justify-between'>
            <div className='flex gap-[30px] h-[40px]'>
              <img src={tanzaniaSpecialistLogo} />
              <img src={africaSafariLogo} />
            </div>
            <div className='flex gap-[24px] items-center max-md:hidden'>
              <NavigationLink className='hover:bg-muted p-3 rounded-md' href={URLS.FLIGHTS}>
                {t('navigation.flights')}
              </NavigationLink>
              <button
                onClick={handleLogout}
                className='text-grey500 font-[MuseoSans900] uppercase tracking-[1.5px] cursor-pointer hover:bg-muted p-3 rounded-md'
              >
                {t('navigation.logout')}
              </button>
              <LanguageSelector />
            </div>
          </div>
        </div>
      </div>
      <MobileNavigation
        openIcon={<Bars3Icon className='h-6 w-6 text-gray-500' />}
        closeIcon={<XMarkIcon className='h-6 w-6 text-gray-700' />}
        handleLogout={handleLogout}
      />
    </Fragment>
  );
};

export default Navigation;
